import {types} from "mobx-state-tree";

export const TextOption = types.model( 'TextOption', {
    id: types.identifier, label: types.string
} );

export const NumericOption = types.model( 'NumericOption', {
    id: types.identifierNumber, label: types.string
} );

export const RoofOptionsModel = types.model( 'RoofOptionsModel', {
    material: types.array( TextOption ), type: types.array( TextOption ), orientation: types.array( TextOption )
} );

export const BatteryOptionsModel = types.model( 'BatteryOptionsModel', {
    defaultCapacity: types.number
} );

export const PanelOptionsModel = types.model( 'PanelOptionsModel', {
    min: types.number, max: types.number, defaultPower: types.number, packageNotFoundMessage: types.maybe( types.string )
} );

export const LeadGenerationOptionsModel = types.model( 'LeadGenerationOptionsModel', {
    roof: types.maybe( RoofOptionsModel ), panel: types.maybe( PanelOptionsModel ), battery: types.maybe( BatteryOptionsModel )
} );
